import $ from 'jquery';

export default class DemandManage {
  constructor($scope, DemandService, PaginationService, UserService, ProductService) {
    $scope.set_user_company_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.filter.user_id = ui.item.id;
          $scope.$apply();
        }
      });
    };

    $scope.$watch('filter.product_category_id', function() {
      ProductService.get_groups($scope.filter.product_category_id).then(function(data) {
        $scope.product_groups = data.groups;
      });
    });

    $scope.select2_options = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '300px'
    };

    $scope.delete_demand = function(demand) {
      if (confirm('Are you sure you want to delete this demand?')) {
        var index = $scope.demands.indexOf(demand);
        if (index > -1) {
          DemandService.delete($scope.demands[index].id).then(function(data) {
            if (data.success)
              $scope.demands.splice(index, 1);
          });
        }
      }
    };

    $scope.get_demands = function() {
      DemandService.get_manage_data($scope.filter).then(function(data) {
        $scope.demands = data.demands;
        $scope.pagination = PaginationService.get_pagination(data.pagination);
      });
    };

    $scope.get_page_data = function(page) {
      $scope.filter.page = page;
      $scope.get_demands();
    };

    $scope.filter = {
      page: 1,
      title: '',
      user_id: '',
      product_category_id: '',
      product_group_id: '',
      has_epaper_title: 'all',
      user_countries: [],
      is_visible: 'all',
      based_to: 'all'
    };

    $scope.init = function() {
      $scope.set_user_company_autocomplete($('input.user_company'));
      $scope.get_demands();
    };

    $scope.init();
  }
}

DemandManage.$inject = ['$scope', 'DemandService', 'PaginationService', 'UserService', 'ProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/demand-manage.ctrl.js